import React from 'react';
import styles from './error.module.scss';

import CloseIcon from '../../img/icons/closeIcon';

const Error = (props) => {

  const { text, onClick, showCloseIcon } = props;

  return (
      <div className={styles.error}>
        { text }
        {
            showCloseIcon &&
            <CloseIcon className="closeIcon" size="10" color="#fff" onClick={onClick} />
        }
      </div>
    );
}

export default Error;
